<template>
  <div id="blood-sugar-list-container">
    <div class="row">
      <div class="col-sm">
        <select
          class="form-control"
          v-model="store.state.bloodSugarView.selectedSortingOption"
          v-on:change="sort"
        >
          <option
            v-for="sortingOption in store.state.bloodSugarView.sortingOptions"
            v-bind:key="sortingOption"
            v-bind:value="sortingOption"
          >{{ sortingOption }}</option>
        </select>
      </div>
      <div class="col-sm"></div>
    </div>
    <div class="mb-3 hidden-md-up"></div>
    <div>
      <bloodSugar-card
        v-for="measurement in measurements"
        v-bind:key="measurement.id"
        :measurement="measurement"
      />
    </div>
  </div>
</template>

<script>
import { store } from "@/store.js";
import BloodSugarCard from "@/components/BloodSugarCard.vue";

export default {
  name: "BloodSugarList",
  components: {
    BloodSugarCard
  },
  data: function() {
    return {
      store: store,
      measurements: []
    };
  },
  computed: {
    selectedSortingOption: function() {
      return this.store.state.bloodSugarView.selectedSortingOption;
    }
  },
  created: function() {},
  mounted: function() {
    this.updateMeasurementsFromStore();
  },
  methods: {
    updateMeasurementsFromStore() {
      this.measurements = [...store.state.bloodSugarMeasurements];
      this.sort();
    },
    sortOldestFirst: function() {
      this.measurements.sort(this.store.compareByDatetimeOldestFirst);
    },
    sortNewestFirst: function() {
      let self = this;
      this.measurements.sort(function(a, b) {
        return self.store.compareByDatetimeOldestFirst(a, b) * -1;
      });
    },
    sortHighestFirst: function() {
      let self = this;
      this.measurements.sort(function(a, b) {
        return self.store.compareByMeasurementHighestFirst(
          a.measurement,
          b.measurement
        );
      });
    },
    sortLowestFirst: function() {
      let self = this;
      this.measurements.sort(function(a, b) {
        return (
          self.store.compareByMeasurementHighestFirst(
            a.measurement,
            b.measurement
          ) * -1
        );
      });
    },
    sort: function() {
      if (this.selectedSortingOption == "Newest first") {
        this.sortNewestFirst();
      } else if (this.selectedSortingOption == "Oldest first") {
        this.sortOldestFirst();
      } else if (this.selectedSortingOption == "Highest measurement first") {
        this.sortHighestFirst();
      } else if (this.selectedSortingOption == "Lowest measurement first") {
        this.sortLowestFirst();
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#blood-sugar-list-container {
  margin-top: 1rem;
}
</style>
